namespace Gamification.Gamification {
    export interface ApiScriptUtenteForm {
        IdApi: Serenity.LookupEditor;
        IdProdotto: Serenity.LookupEditor;
        IdApiOperazione: Serenity.LookupEditor;
        IdProdottoBadge: Serenity.LookupEditor;
        BadgeMostra: Serenity.EnumEditor;
        BadgeNome: Serenity.BooleanEditor;
        BadgeDescrizione: Serenity.BooleanEditor;
        BadgeImmagine: Serenity.BooleanEditor;
        BadgeImmagineFileName: Serenity.ImageUploadEditor;
        MostraEsperienza: Serenity.EnumEditor;
        IdProdottoEsperienza: Serenity.LookupEditor;
        EsperienzaNome: Serenity.BooleanEditor;
        EsperienzaDescrizione: Serenity.BooleanEditor;
        EsperienzaClassi: Serenity.BooleanEditor;
        EsperienzaMigliorPunteggio: Serenity.BooleanEditor;
        EsperienzaPeggiorPunteggio: Serenity.BooleanEditor;
        EsperienzaUltimoPunteggio: Serenity.BooleanEditor;
        MostraTask: Serenity.EnumEditor;
        IdProdottoEsperienzaForTask: Serenity.LookupEditor;
        IdProdottoEsperienzaTask: Serenity.LookupEditor;
        TaskNome: Serenity.BooleanEditor;
        TaskDescrizione: Serenity.BooleanEditor;
        TaskStatus: Serenity.BooleanEditor;
    }

    export class ApiScriptUtenteForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.ApiScriptUtente';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ApiScriptUtenteForm.init)  {
                ApiScriptUtenteForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.EnumEditor;
                var w2 = s.BooleanEditor;
                var w3 = s.ImageUploadEditor;

                Q.initFormType(ApiScriptUtenteForm, [
                    'IdApi', w0,
                    'IdProdotto', w0,
                    'IdApiOperazione', w0,
                    'IdProdottoBadge', w0,
                    'BadgeMostra', w1,
                    'BadgeNome', w2,
                    'BadgeDescrizione', w2,
                    'BadgeImmagine', w2,
                    'BadgeImmagineFileName', w3,
                    'MostraEsperienza', w1,
                    'IdProdottoEsperienza', w0,
                    'EsperienzaNome', w2,
                    'EsperienzaDescrizione', w2,
                    'EsperienzaClassi', w2,
                    'EsperienzaMigliorPunteggio', w2,
                    'EsperienzaPeggiorPunteggio', w2,
                    'EsperienzaUltimoPunteggio', w2,
                    'MostraTask', w1,
                    'IdProdottoEsperienzaForTask', w0,
                    'IdProdottoEsperienzaTask', w0,
                    'TaskNome', w2,
                    'TaskDescrizione', w2,
                    'TaskStatus', w2
                ]);
            }
        }
    }
}
